<script lang="ts">
  /** Set an id for the top-level element */
  export let id = "ccs-" + Math.random().toString(36);
  import { getContext } from "svelte";

  const { selectedContent, addContent, tabs, contentById } = getContext("Tabs");

  addContent({ id });

  export let customClasses = '';

  $: selected = $selectedContent === id;
  $: selectedHiddenFlag = selected ? undefined : '' as any // somehow jsx thinks hidden should be boolean
  $: index = $contentById[id].index;
  $: tabId = $tabs[index].id;

</script>

<div
  role="tabpanel"
  aria-labelledby="{tabId}"
  aria-hidden="{!selected}"
  hidden="{selectedHiddenFlag}"
  id="{id}"
  class:bx--tab-content="{true}"
  class="{customClasses}"
  {...$$restProps}
>
  <slot />
</div>
